/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import { ModelOutput, IModelOutputBaseConfig } from "../ModelOutput";
import { ModelInput } from "../ModelInput";

/**
 * Formula output configuration
 */
export interface IOutputFormulaConfig extends IModelOutputBaseConfig {
	fn: (inputs: { [K: string]: ModelInput<any, any, any> }) => number;
}

/**
 * Custom function output
 */
export class ModelOutputFormula extends ModelOutput<number, IOutputFormulaConfig> {

	protected compute(inputs: { [K: string]: ModelInput<any, any, any> }) {

		return this.config.fn(inputs);

	}

}

/**
 * Formula field
 *
 * @param opts Options
 */
export function outputFormula(opts: IOutputFormulaConfig) {

	return (handler) =>
		new ModelOutputFormula(handler, "formula", 0, opts);

}
